<template>
    <ModalFormCard :action="action" class="modal-default wide" v-bind="{ errors, saving }">
        <template #title>{{ isEdit ? 'Edit' : 'Create new' }} note</template>

        <Textarea
            v-model:value="value.description"
            :disabled="saving"
            class="transition-all duration-500 ease-in-out"
            label="Note"
            name="description"
            placeholder="Description"
            rows="6"
        />

        <div v-if="deals != undefined && deals != null" class="grid grid-cols-1 gap-3 mt-4">
            <CanHaveDeal :contactId="contactId" :modelId="modelId" :modelType="modelType" :deals="_options.deals" />
        </div>

        <template v-else>
            <input type="hidden" :value="contactId" name="belongs_id" />
            <!-- was hard coded to 103? -->
            <input type="hidden" :value="modelType" name="belongs_type" />
        </template>

        <div class="grid grid-cols-4 pt-6">
            <ButtonSaving :disabled="saving" class="button-black h-12 col-span-2" name="published_at" value="1"> Post note </ButtonSaving>

            <button :disabled="saving" :value="null" class="button-purple h-12 col-span-1" name="published_at">Save draft</button>
        </div>
    </ModalFormCard>
</template>

<script>
import Note from '~/models/note.js'
import Modal from '~/mixins/modal.js'
import CanHaveDeal from '~/components/customer/blocks/can-have-deal.vue'

export default {
    mixins: [Modal],

    created() {
        this.setup(Note)
    },

    computed: {
        contactId() {
            if (this.editingModel != null && parseInt(this.editingModel.belongs_type) == 103) {
                return this.editingModel.belongs.contact_id
            }

            return this.editingModel?.belongs_id || this.modelId
        },
    },

    components: {
        CanHaveDeal,
    },
}
</script>
